import { Controller } from "@hotwired/stimulus"

// Il modulo «Prepara una bozza di registrazione» (components/RichiesteErogazione.js, 31a5bd1):
// - FattiSal: qualunque modifica ai dati documentati (importi, date, scelte, caselle, riferimento) toglie la spunta di
//   «Confermo di aver verificato questi dati e i relativi documenti» (set({...}) → confermati: false); la spunta stessa
//   la mette e la toglie l'operatore (onChange diretto).
// - il cambio di tipo svuota le quote (quote: {}) e, per l'anticipo, le toglie del tutto (non si rendono né si inviano).
//   <form data-controller="fatti-sal"> <details data-action="input->fatti-sal#modifica change->fatti-sal#modifica">
//     <input type="checkbox" data-fatti-sal-target="conferma"> … <select data-fatti-sal-target="tipo" data-action="change->fatti-sal#cambiaTipo">
//     <div data-fatti-sal-target="quote"><input name="quote[…]">
export default class extends Controller {
  static targets = ["conferma", "tipo", "quote"]

  modifica(event) {
    if (event.target === this.confermaTarget) return
    this.confermaTarget.checked = false
  }

  cambiaTipo() {
    const anticipo = this.tipoTarget.value === "anticipo"
    this.quoteTargets.forEach((blocco) => {
      blocco.hidden = anticipo
      blocco.querySelectorAll("input").forEach((campo) => {
        campo.value = ""
        campo.disabled = anticipo
      })
    })
  }
}
